import { Input } from "@/components/ui/input";

export const TeamNames = ({ state, send }) => (
  <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-2" data-testid="team-names">
    {state.teams.map((t) => (
      <div key={t.id} className="flex items-center gap-2">
        <span className="h-4 w-4 rounded-full shrink-0" style={{ backgroundColor: t.color }} />
        <Input defaultValue={t.name} maxLength={40} className="h-10" data-testid={`team-name-${t.id}`}
          onBlur={(e) => e.target.value.trim() && e.target.value !== t.name && send({ type: "cmd", action: "rename_team", team_id: t.id, name: e.target.value })} />
      </div>
    ))}
  </div>
);

export const OPTION_COLORS = { a: "#FF7A1A", b: "#34D399", c: "#3B82F6", d: "#EC4899" };

export const formatSec = (ms) => Math.ceil((ms || 0) / 1000);
